module.exports = __webpack_public_path__ + "img/messages2.d0932325.png";